import review from './review'

export default {
  review
}
